/* eslint-disable react/display-name */
/* eslint-disable no-param-reassign */
import React, { useMemo, useState } from 'react'
import ReactTable from 'react-table'
import { Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import dayjs from 'dayjs'
import axios from 'axios'

import useSwrPagination from '../../../hooks/useSwrPagination'
import { updateSwrCache } from '../../../common/utils'

const fullSize = { xs: 12, lg: 12, md: 12 }

const swrKey = '/subject/admin/deliveries'

const ListDeliveries = () => {
  const [selectedDeliveries, setSelectedDeliveries] = useState({})
  const [pageQty, setPageQty] = useState(1)

  const { data: deliveries } = useSwrPagination(swrKey, pageQty, {
    startDate: dayjs()
      .subtract(1, 'd')
      .format('YYYY-MM-DD'),
    endDate: dayjs()
      .add(1, 'd')
      .format('YYYY-MM-DD'),
  })

  const sortedDeliveries = useMemo(
    () =>
      deliveries.sort((a, b) => {
        if (Date.parse(a.created) < Date.parse(b.created)) return 1
        return -1
      }),
    [deliveries]
  )

  const toggleDelivery = (delivery) => {
    if (delivery.checkoutDate) return

    if (selectedDeliveries[delivery.packageid]) {
      setSelectedDeliveries({
        ...selectedDeliveries,
        [delivery.packageid]: undefined,
      })
    } else {
      setSelectedDeliveries({
        ...selectedDeliveries,
        [delivery.packageid]: delivery,
      })
    }
  }

  const renderCell = ({ original, index, value }) => {
    let backgroundColor = 'inherit'
    if (original.checkoutDate) backgroundColor = 'yellow'
    if (selectedDeliveries[original.packageid] !== undefined && backgroundColor === 'inherit') backgroundColor = 'lightgreen'

    return (
      <div onMouseDown={() => toggleDelivery(original)} style={{ cursor: 'pointer', backgroundColor }}>
        {value}
      </div>
    )
  }

  const sendDLV = async () => {
    const deliveriesToUpdate = Object.values(selectedDeliveries).map((d) => ({ carrierId: d.carrierId, packageid: d.packageid, delivered: true }))

    await axios.put(`${window.MYQLOCX_API}/subject/admin/bi/finishdeliveries`, deliveriesToUpdate)

    updateSwrCache(swrKey, (prev) => {
      for (const d of deliveries) {
        for (let i = 0; i < prev.length; i++) {
          const del = prev[i]
          if (d.packageid === del.packageid) prev[i].checkoutDate = new Date().toISOString()
        }
      }

      return prev
    })

    setSelectedDeliveries({})
  }

  return (
    <Grid fluid>
      <Row>
        <Col {...fullSize}>
          <h4>
            Se leveranser <Glyphicon style={{ cursor: 'pointer' }} glyph="glyphicon glyphicon-refresh" onClick={() => updateSwrCache(swrKey, (p) => p)}></Glyphicon>
          </h4>
        </Col>
      </Row>
      <Row>
        <Col {...fullSize}>
          <ReactTable
            data={sortedDeliveries}
            filterable
            columns={[
              {
                Header: '_id:',
                id: '_id',
                accessor: (d) => d._id,
                Cell: renderCell,
              },
              {
                Header: 'Skapad:',
                id: 'created',
                accessor: (d) => dayjs(d.created).format('HH:mm - DD/MM/YY'),
                Cell: renderCell,
              },
              {
                Header: 'Avslutad:',
                id: 'finished',
                accessor: (d) => (d.checkoutDate ? d.checkoutDate : ''),
                Cell: renderCell,
              },
              {
                Header: 'Paketid:',
                id: 'packageId',
                accessor: (d) => d.packageid,
                Cell: renderCell,
              },
              {
                Header: 'Mottagare:',
                id: 'receiver',
                accessor: (d) => d.to_customer && `${d.to_customer.name},${d.to_customer.company ? ` ${d.to_customer.company}, ` : ', '}${d.to_customer.phone}`,
                Cell: renderCell,
              },
              {
                Header: 'Avsändarnamn:',
                id: 'senderName',
                accessor: (d) => d.vendorName,
                Cell: renderCell,
              },
              {
                Header: 'Transportör:',
                id: 'carrierId',
                accessor: (row) => <img style={{ maxWidth: 50 }} src={row.carrierImage} />,
                Cell: renderCell,
              },
            ]}
            NoDataComponent={() => null}
            showPagination={true}
            showPageSizeOptions={false}
            loading={!deliveries}
            loadingText="Laddar..."
            pageSize={20}
            className="-striped -highlight"
            sortable={true}
            onPageChange={(page) => setPageQty(page + 1)}
          />
        </Col>
      </Row>
      <br />
      <Row style={{ backgroundColor: 'white', border: '1px solid rgba(0,0,0,0.1)', padding: 20 }}>
        <Col xs={12} md={4} lg={4}>
          <div className="qSaveButton" onClick={sendDLV}>
            Skicka status DLV på {Object.keys(selectedDeliveries).length} leveranser
          </div>
        </Col>
        <Col xs={12} md={4} lg={4}>
          {/* <div className="qSaveButton">Skicka status DOT på {Object.keys(this.state.selectedDeliveries).length} leveranser</div> */}
        </Col>
        <Col xs={12} md={4} lg={4}>
          {/* <div className="qSaveButton">Skicka status DLV på {Object.keys(this.state.selectedDeliveries).length} leveranser</div> */}
          ...
        </Col>
      </Row>
    </Grid>
  )
}

export default ListDeliveries
